import { gql } from '__generated__';

export default gql(`
  mutation EditNote($input: EditNoteInput!) {
    editNote(input: $input) {
      id
    }
  }
`);
